import { Component, OnInit } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import { UserService } from '../../../../core/user.service';
import { CqmnsProjectPopupComponent } from "../../../../_models/cqmns-project-popup/cqmns-project-popup.component";
import {MatDialog, MatDialogConfig} from "@angular/material";
import { AuthService } from '../../../../core/auth/auth.service';

@Component({
  selector: 'app-cqmns-selected-rca',
  templateUrl: './cqmns-selected-rca.component.html',
  styleUrls: ['./cqmns-selected-rca.component.css']
})
export class CqmnsSelectedRcaComponent implements OnInit {
  hostUrl =this.userService.getUrl();
  projectId: any;
  headers = new HttpHeaders();
  rca : any;
  len : any;
  rcalen : any;
  rcaoptn : any;
  k : any;
  loader: boolean;
  message: any;
  message1: any;
  message2: any;
  size: any;
  p:any;
  source: any =[];
  messages:any;
  sortID = "fa fa-sort";
  sortDescription = "fa fa-sort";
  sortAccuracy = "fa fa-sort";
  isDesc = false;
  order=true;
  oldField="";
  project:any;
  projectName:any;
  rootcauses: any = [];
  rootcause: any =[];
  userId: any;
  constructor(private http: HttpClient, 
    private userService: UserService, 
    private router: Router, 
    private route: ActivatedRoute, private authService: AuthService, 
    private matDialog: MatDialog) { }

  ngOnInit() {
  
    this.authService.user() .subscribe(
      data => {});
      this.userId = localStorage.getItem("userid");

   // this.projectId = this.route.snapshot.params['projectId'];
   this.projectId = localStorage.getItem("projectId");
   this.projectName = localStorage.getItem("cqm-project-name");
   let rdata = localStorage.getItem('rca');
   console.log(rdata)
   if(rdata){
   let headers = new HttpHeaders();
   headers = headers.append('Content-Type', 'application/json');
   this.http.post(encodeURI(this.hostUrl + '/api/issue/rca/'+this.projectId), rdata, { headers: headers })
   .subscribe(data => {
    this.rca =  data;
   //  for(let i =0; i<=this.rca.length;i++){
   //   this.rootcauses.push(this.rca[i].RootCause)
   //  this.rootcauses= [
   //   "violations of standards",
   //   "unavailability of usability requirements",
   //   "lack of knowledge of standards"
   // ];
   //   console.log(this.rootcauses)
   //   for(let j =0; j<=this.rootcauses.length;j++){
   //     this.rootcause.push(this.rootcauses[j].charAt(0).toUpperCase()+this.rootcauses[j].slice(1));
   //     }
   //  }
    this.len=this.rca.length;
    this.size=0;
    for(let j = 0;j<this.len;j++){
     this.size += (this.rca[j]['RootCause']).length; 
    }
 });
     this.http.get(encodeURI(this.hostUrl+'/api/issue/sourceClassification/' + this.projectId))
     .subscribe( data => {
         this.messages=data;
         for(let i =0; i<=this.messages.length;i++){
           if(this.messages[i]){
              this.source = this.messages[i].source;
           }
         }
         });
         this.http
         .get(
           encodeURI(
             this.hostUrl + "/api/issue/activatedProjects/" + this.projectId
           )
         )
         .subscribe(data => {
           this.project = data;
           for (let i = 0; i <= this.project.length; i++) {
             if(this.project[i]){
           this.projectName = this.project[i].project_name;
             }
           }
         });
        }
 }
 disapprove(issueid){
  for (let i = 0; i < this.rca.length; i++) {
    if (this.rca[i].ID === issueid) {                  
        this.rca.splice(i, 1);
    }
}
  // const url = "/cqmns-recommend-rca" ;
  //   this.router.navigate([url]);
 }
 // goToApprovedRca(){
 //   console.log(this.projectId)
 //   const url ='/rcaapproveddefects/' + this.projectId;
 //   this.router.navigate([url]);
 //   }
 onSubmit(id,issueid) {
   
   // console.log(id);
   let rdata = [];
   console.log(this.size);
       for( let i = 0 ; i< 3 ; i++){
        if((<HTMLInputElement>document.getElementsByClassName("checkedrca")[i]).checked){
         rdata.push((<HTMLInputElement>document.getElementsByClassName("checkedrca")[i]).value); 
         ((<HTMLInputElement>document.getElementsByClassName("checkedrca")[i]).checked = false) ; 
       }
     }
    let retrain = [];
    retrain.push(id,rdata,issueid);
    console.log(retrain);

    let headers = new HttpHeaders();
           headers = headers.append('Content-Type', 'application/json');
           this.loader = true;
             this.http.post(encodeURI(this.hostUrl + '/api/rootcause/retrainDataRCA/'+ this.projectId), retrain , { headers: headers })
               .subscribe(data => {
                this.loader = false;
                 this.message=data;    
                 if (this.message.successmsg == "Success") {
                  for (let i = 0; i < this.rca.length; i++) {
                    if (this.rca[i].ID === issueid) {                  
                        this.rca.splice(i, 1);
                    } 
                    if(this.rca.length === 0){
                      const url ='/cqmns-approved-rca';
                      this.router.navigate([url]);
                      localStorage.removeItem('rca'); 

                    }
                  }
                   let headers = new HttpHeaders();
                     headers = headers.append('Content-Type', 'application/json');
                     this.loader = true;
                       this.http.post(encodeURI(this.hostUrl + '/api/rootcause/uploadRetrainFileRCA/'+ this.projectId) , { headers: headers })
                         .subscribe(data => {
                          this.loader = false;
                           this.message1=data;
                           if (this.message1.successmsg == "Uploaded") {
                            // const url ="/cqmns-approved-rca"
                            // this.router.navigate([url]);
                            //  let headers = new HttpHeaders();
                            //    headers = headers.append('Content-Type', 'application/json');
                            //      this.http.post(encodeURI(this.hostUrl + '/api/rootcause/retrainRCA/'+ this.projectId) , { headers: headers })
                            //        .subscribe(data => {
                            //          this.message2=data; 
                            //          if(this.message2.successmsg == "Retrained"){
                                       

                            //            alert("Retrained Successfully");


                            //            console.log('0')

                            //          }

                            //         console.log('1')
                            //      });
                                // this.goToApprovedRca();
                                for (let i = 0; i < this.rca.length; i++) {
                                 if (this.rca[i].ID === issueid) { 
                                     this.rca.splice(i, 1);
                                 }
                                 if(this.rca.length === 0){
                                  const url ='/cqmns-approved-rca';
                                  this.router.navigate([url]);
                                  localStorage.removeItem('rca'); 
            
                                }
                             }
                           }
                       });
                 }
                 
                
             });             
 }

 onDone() {
   const url ='/cqmns-approved-rca';
   this.router.navigate([url]);
}
sortBy(field){
 if(this.oldField==field){
     this.isDesc = !this.isDesc;
     this.order=!this.order;
 } else {
     this.isDesc = false;
     this.order=false;
     this.oldField=field;
 }
 if(this.order){
     field="-"+field;
 }
 if (field === 'ID' || field === '-ID') {
     this.sortID = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
     this.sortDescription = "fa fa-sort";
     this.sortAccuracy = "fa fa-sort";
    
 } else if (field === 'Description' || field === '-Description') {
     this.sortDescription = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
     this.sortID = "fa fa-sort";
     this.sortAccuracy = "fa fa-sort";
    
 } else if (field === 'Accuracy' || field === '-Accuracy') {
     this.sortAccuracy = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
     this.sortDescription = "fa fa-sort";
     this.sortID = "fa fa-sort";
 } 
 this.rca=this.rca.sort(this.userService.dynamicSort(field))
}

projectPopup() {
    

  const dialogConfig = new MatDialogConfig();

  // dialogConfig.panelClass = "login-modalbox";

  dialogConfig.backdropClass = 'popupBackdropClass';

  dialogConfig.maxHeight = window.innerHeight - 20 + 'px' ; 

  dialogConfig.panelClass = "ns-modalbox";
  dialogConfig.disableClose = false;
  this.matDialog.open(CqmnsProjectPopupComponent, dialogConfig);

}
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-actions/cqmns-selected-rca/cqmns-selected-rca.component.ts